import type { GameDetail, GameTypeDetail, PartnerGame } from './types';

const actorId = '00000000-0000-4000-8000-000000000001';

export const gameTypeFixtures: readonly GameTypeDetail[] = Object.freeze([
  Object.freeze({
    id: '00000000-0000-4000-8000-000000000901',
    code: 'SLOT',
    name: 'Slots',
    status: 'ACTIVE',
    effectiveStatus: 'ACTIVE',
    dependencyBlockers: [] as string[],
    createdAt: '2026-07-20T10:00:00+07:00',
    createdBy: actorId,
    updatedAt: '2026-07-22T12:00:00+07:00',
    updatedBy: actorId,
  }),
  Object.freeze({
    id: '00000000-0000-4000-8000-000000000902',
    code: 'LIVE',
    name: 'Live Casino',
    status: 'SUSPENDED',
    effectiveStatus: 'SUSPENDED',
    dependencyBlockers: ['ACTIVE_GAMES'],
    createdAt: '2026-07-18T03:00:00Z',
    createdBy: actorId,
    updatedAt: '2026-07-21T04:30:00Z',
    updatedBy: actorId,
  }),
]);

export const gameFixtures: readonly GameDetail[] = Object.freeze([
  Object.freeze({
    id: '00000000-0000-4000-8000-000000000911',
    gameType: {
      id: gameTypeFixtures[0]!.id,
      code: 'SLOT',
      name: 'Slots',
      status: 'ACTIVE' as const,
    },
    code: 'SLOT-ROYAL',
    name: 'Royal Slot',
    status: 'ACTIVE',
    effectiveStatus: 'ACTIVE',
    dependencyBlockers: [] as string[],
    createdAt: '2026-07-20T10:00:00+07:00',
    createdBy: actorId,
    updatedAt: '2026-07-22T12:00:00+07:00',
    updatedBy: actorId,
  }),
  Object.freeze({
    id: '00000000-0000-4000-8000-000000000912',
    gameType: {
      id: gameTypeFixtures[1]!.id,
      code: 'LIVE',
      name: 'Live Casino',
      status: 'SUSPENDED' as const,
    },
    code: 'LIVE-BACCARAT',
    name: 'Live Baccarat',
    status: 'SUSPENDED',
    effectiveStatus: 'SUSPENDED',
    dependencyBlockers: ['GAME_TYPE_NOT_ACTIVE'],
    createdAt: '2026-07-19T10:00:00+07:00',
    createdBy: actorId,
    updatedAt: '2026-07-21T12:00:00+07:00',
    updatedBy: actorId,
  }),
]);

export const partnerGameFixtures: readonly PartnerGame[] = Object.freeze([
  Object.freeze({
    partnerId: '00000000-0000-4000-8000-000000000101',
    game: gameFixtures[0]!,
    status: 'SUSPENDED',
    effectiveStatus: 'SUSPENDED',
    dependencyBlockers: [] as string[],
    currencyCode: 'THB',
    maximumPlayAmount: '5000.000000',
    createdAt: '2026-07-20T10:00:00+07:00',
    createdBy: actorId,
    updatedAt: '2026-07-22T12:00:00+07:00',
    updatedBy: actorId,
  }),
  Object.freeze({
    partnerId: '00000000-0000-4000-8000-000000000101',
    game: gameFixtures[1]!,
    status: 'SUSPENDED',
    effectiveStatus: 'SUSPENDED',
    dependencyBlockers: ['GAME_TYPE_NOT_ACTIVE'],
    currencyCode: 'THB',
    maximumPlayAmount: '2500.000000',
    createdAt: '2026-07-19T10:00:00+07:00',
    createdBy: actorId,
    updatedAt: '2026-07-21T12:00:00+07:00',
    updatedBy: actorId,
  }),
]);
